export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9710.b119c2b9.jpg";